'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;

var _redux = require('redux');

var _actions = require('./actions');

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    updateLocation: (0, _redux.bindActionCreators)(_actions.updateLocation, dispatch)
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/UpdateLocation/selectors.js
// module id = 1277
// module chunks = 0